import ribbit from '../../images/ribbit.png'

export const projectList = [
  {
    name: "Ribbit",
    description: "Blog site where users can make an account and share posts publicly or privately",
    imageUrl: ribbit,
    linkUrl: 'https://ribbit.moe/',
  },
]